<script setup lang="ts">
import type { Canvass } from "@/canvasses/types";
import BottomSheet from "@/components/BottomSheet.vue";
import MapMarkerIcon from "@/components/map/MapMarkerIcon.vue";
import { formatDatetime } from "@/utils/toFormattedDatetime";
import { computed } from "vue";

const props = defineProps<{
  canvass: Canvass;
}>();

const emit = defineEmits<{
  close: [];
}>();

const meetingTime = computed(() => {
  if (props.canvass.meetingPoint.time == null) return null;

  return formatDatetime(props.canvass.meetingPoint.time);
});
</script>

<template>
  <BottomSheet @close="emit('close')">
    <template #title>
      <MapMarkerIcon class="map-marker-meetingpoint" />
      {{ canvass.meetingPoint.description }}
    </template>
    <p>{{ meetingTime }}</p>
  </BottomSheet>
</template>
